import { defineMessages } from 'react-intl';

export const LOCALIZED_STRINGS = defineMessages({
    PrivacyUpdateMessage: {
        id: 'Components.PrivacyUpdateBanner.PrivacyUpdateMessage',
        defaultMessage: 'We’ve updated our Terms of use and Privacy policy.',
    },
    PrivacyUpdateLink: {
        id: 'Components.PrivacyUpdateBanner.PrivacyUpdateLink',
        defaultMessage: 'Take a look',
    },
});

export const ALREADY_READ_TERMS_COOKIE = {
    Key: 'AlreadyReadTermsCookie',
    Value: 'true',
    ExpirationDays: 60,
};